module.exports = __webpack_public_path__ + "img/children-4.c20d3177.jpg";